/* @flow */
const companyRoutes = {
  activity: 'companies/:companyId/activity',
  countries: 'companies/:companyId/countries',
};

export default companyRoutes;
